// extracted by mini-css-extract-plugin
module.exports = {"ProseMirror":"Logo_ProseMirror__ufBS2","logo":"Logo_logo__3IG6m","logo_clickable":"Logo_logo_clickable__124Hz"};